import { CmsVisibility } from '@spa/lib/store/settings/CmsVisibility';
import { GeneralSettings } from '@spa/lib/store/settings/GeneralSettings';
import { RootState } from '../../RootState';

const selectGeneralSettings = (state: RootState): GeneralSettings => {
  const settings = state.settings.settings;

  if (settings === null) {
    throw new Error('General settings should be initialized.');
  }

  return (
    settings.generalSettings ?? {
      decoratedPdpEnabled: false,
      returnProcessEnabled: false,
      recaptchaEnabled: false,
      recaptchaSiteKey: 'invalid',
      searchHubTrackingEnabled: false,
      preOrderEnabled: false,
      fsk18HDEnabled: false,
      orderRepositoryServiceApiEnabled: false,
      amazonPayEnabled: false,
      invoicesEnabled: false,
      amazonPayCartButtonEnabled: false,
      amazonPayEndOfCheckoutOptionEnabled: false,
      checkoutDeliverySelectionEnabled: false,
      applePayEnabled: false,
      googlePayEnabled: false,
      emarsysNewsletterEnabled: false,
      emarsysMbsNewsletterEnabled: false,
      employeeDiscountEnabled: false,
      prepaymentCcEnabled: false,
      icecatIntegrationEnabled: false,
      showProductTestEnabled: false,
      bazaarvoiceEnabled: false,
      giftCardsBalanceCheckEnabled: false,
      giftCardsRedeemEnabled: false,
      allCategoriesMenuVisibility: CmsVisibility.INVISIBLE
    }
  );
};

export default selectGeneralSettings;
